import { useCallback } from 'react';

import { useUserContext } from '@/modules/auth/hooks/useUser';

import { useAssignArticleMutation } from '../graphql/mutation/generated/AssignArticle';

const useAssignArticle = (courseId: string) => {
  const user = useUserContext();
  const [{ fetching, data, error }, assignArticlePromise] = useAssignArticleMutation();

  const assignArticle = useCallback(() => {
    return assignArticlePromise({
      input: {
        userIds: [user.id],
        entityIds: [courseId],
        notificationSettings: { sendNotification: false },
        enrollmentSettings: { selfEnrolled: true },
      },
    });
  }, [assignArticlePromise, courseId, user.id]);

  return {
    fetching,
    data,
    error,
    assignArticle,
  };
};

export default useAssignArticle;
